import { Action } from './Action';
import { actions, AddToastPayload } from 'react-redux-toastr';
import merge from 'lodash/merge';

export const toast = {
  showSucceeded: (payload: Partial<AddToastPayload>) => {
    const finalPayload = merge(
      {
        type: 'success',
        message: 'Operation succeeded.',
        position: 'top-center',
        options: {
          showCloseButton: true,
          timeOut: 3000,
          transitionIn: 'fadeIn',
          transitionOut: 'fadeOut',
          className: 'successToast',
          progressBar: false,
        },
      },
      payload,
    );
    return actions.add(finalPayload as AddToastPayload) as Action;
  },

  showFailed: (payload: Partial<AddToastPayload>) => {
    const finalPayload = merge(
      {
        type: 'error',
        message: 'Operation failed.',
        position: 'top-center',
        options: {
          showCloseButton: true,
          timeOut: 0,
          transitionIn: 'fadeIn',
          transitionOut: 'fadeOut',
          className: 'errorToast',
          progressBar: false,
        },
      },
      payload,
    );
    return actions.add(finalPayload as AddToastPayload) as Action;
  },

  showInfo: (payload: Partial<AddToastPayload>) => {
    const finalPayload = merge(
      {
        type: 'info',
        message: 'Info.',
        position: 'top-center',
        options: {
          showCloseButton: true,
          timeOut: 3000,
          transitionIn: 'fadeIn',
          transitionOut: 'fadeOut',
          className: 'infoToast',
          progressBar: false,
        },
      },
      payload,
    );
    return actions.add(finalPayload as AddToastPayload) as Action;
  },
};


const FLASH_KEY = 'upstream.flashMessages';

export type FlashKind = 'success' | 'error' | 'info';
export type FlashMessage = { kind: FlashKind; message: string; title?: string };

const safeParse = (s: string | null) => {
  try { return s ? JSON.parse(s) : []; } catch { return []; }
};

export const addFlashMessage = (msg: FlashMessage) => () => {
  try {
    const q = safeParse(localStorage.getItem(FLASH_KEY));
    q.push({ ...msg, ts: Date.now() });
    localStorage.setItem(FLASH_KEY, JSON.stringify(q));
  } catch {
    // tslint:disable-next-line:no-console
    console.log('Failed to add flash message:', msg);
  }
};


export const consumeFlashMessages = () => (dispatch: any) => {
  try {
    const q = safeParse(localStorage.getItem(FLASH_KEY)) as (FlashMessage & { ts?: number })[];
    localStorage.removeItem(FLASH_KEY);

    q.forEach((m) => {
      switch (m.kind) {
        case 'success':
          dispatch(toast.showSucceeded({ title: m.title, message: m.message }));
          break;
        case 'error':
          dispatch(toast.showFailed({ title: m.title, message: m.message }));
          break;
        default:
          dispatch(toast.showInfo({ title: m.title, message: m.message }));
          break;
      }
    });
  } catch {
    localStorage.removeItem(FLASH_KEY);
  }
};